<template>
    <article class="patient-search-teaser" :class="{'patient-search-teaser--compact': compact, 'patient-search-teaser--fixed-height': fixedHeight}">
        <figure class="patient-search-teaser__avatar">
            <img v-if="patient.photo_path" :src="patient.photo_path" class="patient-search-teaser__photo">
            <frm-icon v-else class="patient-search-teaser__icon" name="patient" />
        </figure>
        <header class="patient-search-teaser__name-address">
            <h3 class="patient-search-teaser__name">
                {{ patient.name.fullname }}
            </h3>
            <p v-if="compact" class="patient-search-teaser__address">
                {{ compactAddress }}
            </p>
            <p v-else class="patient-search-teaser__address" :class="{'patient-search-teaser__address--fixed-height': fixedHeight}" v-html="address" />
        </header>
        <p v-if="patient.birthdate || patient.identification_number" class="patient-search-teaser__dob-id">
            <span v-if="patient.birthdate" class="patient-search-teaser__dob">
                {{ $ds(patient.birthdate, 'date') }}
                <frm-deceased-icon v-if="patient.deceased" :date="$ds(patient.deceased_date, 'date')" />
            </span>
            <span v-if="compact && patient.birthdate && patient.identification_number" class="patient-search-teaser__detail-separator">|</span>
            <span v-if="patient.identification_number" class="patient-search-teaser__id">
                {{ patient.identification_number }}
            </span>
        </p>
    </article>
</template>

<script>
    export default {
        props: {
            compact: {
                type: Boolean,
                default: false,
            },
            patient: {
                type: Object,
                required: true,
            },
            showExtendedAddress: {
                type: Boolean,
                default: false,
            },
            fixedHeight: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            compactAddress() {
                const address = this.patient.address || {};
                const houseNumber = [address.house_number, address.house_number_suffix].filter(Boolean).join('');
                const street = [address.street, houseNumber].filter(Boolean).join(' ');

                return [street, address.city].filter(Boolean).join(', ');
            },

            address() {
                return this.showExtendedAddress ? this.patient.address_extended_formatted : this.patient.address_formatted;
            },
        },
    };
</script>
